import { useState } from 'react';

export const useWillMount: (callback: () => void) => void = (callback = () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callback();
  setHasBeenCalled(true);
};
